import React from 'react'
import PropTypes from 'prop-types'

const linkSorter = (a, b) => a.value.localeCompare(b.value)

const generateLinkLists = (ghoValue) => [
  {
    title: `GitHub Organization: ${ghoValue}`,
    url: `https://git.i.mercedes-benz.com/${ghoValue}`,
  },
  {
    title: 'Build Pipeline',
    url: `https://jenkins-build.cicd.intra.oneweb.mercedes-benz.io/job/build-${ghoValue}`,
  },
  {
    title: 'Non-PROD Deploy Pipelines',
    url: `https://jenkins-build.cicd.intra.oneweb.mercedes-benz.io/job/deploy-${ghoValue}`,
  },
  {
    title: 'PROD Deploy Pipelines',
    url: `https://jenkins.cicd.intra.oneweb.mercedes-benz.io/job/deploy-${ghoValue}`,
  },
]

const LinksList = ({ ghoValue }) => (
  <ul className="wb-list wb-list--unordered wb-list--offset-xs">
    {generateLinkLists(ghoValue).map(({ title, url }) => (
      <li className="wb-list__item" key={title}>
        {
          <a
            className="wb-link wb-link--standalone"
            target="_blank"
            rel="noreferrer"
            href={url}
          >
            {title}
          </a>
        }
      </li>
    ))}
  </ul>
)

LinksList.propTypes = {
  ghoValue: PropTypes.string,
}

const GhoTabs = ({ items }) => (
  <wb-tabs selected={items[0].value}>
    <wb-tab-bar fitted>
      {items.map((item) => (
        <wb-tab name={item.value} key={item.value}>
          {item.value}
        </wb-tab>
      ))}
    </wb-tab-bar>

    {items.map(({ value }) => (
      <wb-tab-content name={value} key={value}>
        <LinksList ghoValue={value} />
      </wb-tab-content>
    ))}
  </wb-tabs>
)

GhoTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ),
}

const TenantLinks = ({ githubOrganizations }) => (
  <div className="tenant-body__block">
    <div className="tenant-body__block-label">Links</div>
    {githubOrganizations.length > 1 ? (
      <GhoTabs items={githubOrganizations.sort(linkSorter)} />
    ) : (
      <LinksList ghoValue={githubOrganizations[0].value} />
    )}
  </div>
)

TenantLinks.propTypes = {
  githubOrganizations: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }),
  ),
}

export default TenantLinks
